import css from "../Form.module.css";

const Text = ({ children }) => {
  return (
    <p className={`${css.Text} ${children.className ?? ""}`}>
      {children.value}
    </p>
  );
};

export default Text;
